module.exports = __webpack_public_path__ + "static/media/start.f312d086.svg";